<template>
    <el-container class="asset-snapshot">
        <el-main>
            <div class="snapshot-title column-header">
                <span>资产快照</span>
            </div>
            <div class="snapshot-body">
                <el-table stripe style="width: 100%" :data="handleData">
                    <el-table-column
                    prop="date" label="日期">
                    </el-table-column>
                    <el-table-column
                    prop="name" label="名字">
                    </el-table-column>
                    <el-table-column
                    prop="event" label="操作">
                        <template slot-scope="scope">
                            <el-button size="small" class="btn__style" @click="showSnapBoard(scope.row)">详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-main>
    </el-container>
</template>

<script>
/* eslint-disable */
import { post, get } from "@/api/index";
import { mapState } from "vuex";

export default {
    data: function () {
        return {
            snapshotData: []
        }
    },
    mounted() {
        this.getSnapshot();
    },
    computed: {
        ...mapState([
            'token'
        ]),

        handleData() {
            let new_data = [];
            for (let i=0; i<this.snapshotData.length; i++) {
                let i_data = this.snapshotData[i];
                let i_obj = {
                    id: i_data[0],
                    name: i_data[1],
                    date: i_data[2]
                };
                new_data.push(i_obj);
            }
            return new_data;
        }
    },
    methods: {
        // 获取快照列表
        getSnapshot() {
            var url = this.$baseUrl+'/asset/snapshot/list/get';
            get(url, {token: this.token}).then(res => {
                if (res.code === 200) {
                    this.snapshotData = res.data;
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: '提示',
                        offset: 100
                    });
                }
            })
        },

        // 展示快照面板
        showSnapBoard(data) {
            this.$router.push({
                path: '/assets/snapshot/board',
                query: {
                    key: data.id
                }
            })
        },


    }
}
</script>

<style lang="scss">
.asset-snapshot{
    .el-table {
        tr, th{
            background-color: transparent;
        }
        tbody {
            tr:hover {
                color: #fff;
                background-color: #333;
            }
        }
    }

    .el-table, .el-table__expanded-cell {
        background-color: #2a2d2e;
    }
    .el-table td, .el-table th.is-leaf {
        border-bottom: 1px solid #252425;
    }
    .el-table--striped .el-table__body tr.el-table__row--striped td {
        background: #262829;
    }
    .el-table--enable-row-hover .el-table__body tr:hover>td {
        background-color: #262829;
    }
    .el-table--border::after, .el-table--group::after, .el-table::before {
        background-color: #252425;
    }
    .asset-snapshot .el-table--striped .el-table__body tr.el-table__row--striped td {
        background: #262829;
    }
}
</style>
